import Axios from "axios";
import Apis from "../../config/Apis";
import {
  hideAlert,
  hideLoading,
  showAlert,
  showLoading,
  UpdateTypes,
} from "../Actions/GeneralActions";
// import { headers } from '../../Utils';
import {
  deleteGallery,
  getGallery,
  getSpecificCategory,
  getVendorPhotos,
  updateGallery,
} from "../Actions/InspirationalGalleryActions";
import { headers } from "../../utills";

export const InspirationalGalleryMiddleware = {
  createCategory: ({ name }) => {
    return (dispatch) => {
      return new Promise(async (resolve, reject) => {
        try {
          let formData = new FormData();
          formData.append("name", name);
          const data = await Axios.post(
            Apis.createCategory,
            formData,
            await headers.config()
          );
          if (data?.status == 200) {
            resolve(data?.data?.data);
            // dispatch(UpdateTypes({ inspirationgallery: data?.data?.data }));
          }
        } catch (error) {
          reject(error);
          dispatch(
            showAlert({
              title: "createCategory",
              message: error?.response?.data?.message,
              type: "Error",
              status: error?.response?.status,
            })
          );
        }
      });
    };
  },

  createGallery: (gallery_data) => {
    // console.log("gallery_data", gallery_data);
    return (dispatch) => {
      dispatch(showLoading());
      return new Promise(async (resolve, reject) => {
        try {
          let formData = new FormData();
          formData.append("event_id", gallery_data?.event_id);
          formData.append(
            "client_category_id",
            gallery_data?.client_category_id
          );
          if (gallery_data?.image?.length > 0) {
            for (const [i, element] of gallery_data?.image.entries()) {
              formData.append(`images[${i}]`, element);
            }
          }
          // formData.append("name", gallery_data?.name);
          // formData.append("image", gallery_data?.image);
          formData.append("allow_to_view", gallery_data?.allow_to_view);

          if (gallery_data?.vendors) {
            for (const [i, element] of gallery_data?.vendors.entries()) {
              formData.append(`vendors[${i}][vendor_id]`, element?.id);
            }
          }
          const data = await Axios.post(
            Apis.createGallery,
            formData,
            await headers.config()
          );
          // console.log(
          //   "data?.data?.data",
          //   JSON.stringify(data?.data?.data, null, 8)
          // );

          if (data?.status == 200) {
            resolve(true);
            dispatch(updateGallery(data?.data?.data));
            dispatch(
              showAlert({
                message: data?.data?.message,
                title: "Create Gallery",
                type: "Success",
              })
            );
          }
        } catch (error) {
          reject(error);
          dispatch(
            showAlert({
              title: "createCategory",
              message: error?.response?.data?.message,
              type: "Error",
              status: error?.response?.status,
            })
          );
        } finally {
          dispatch(hideLoading());
        }
      });
    };
  },
  updateGallery: (gallery_data) => {
    return (dispatch) => {
      dispatch(showLoading());
      return new Promise(async (resolve, reject) => {
        try {
          let formData = new FormData();
          formData.append("event_id", gallery_data?.event_id);
          formData.append("id", gallery_data?.id);

          if (gallery_data?.client_category_id)
            formData.append(
              "client_category_id",
              gallery_data?.client_category_id
            );
          if (gallery_data?.name) formData.append("name", gallery_data?.name);

          const data = await Axios.post(
            Apis.updateGallery,
            formData,
            await headers.config()
          );

          if (data?.status == 200) {
            resolve(true);
            dispatch(updateGallery(data?.data?.data));
            dispatch(
              showAlert({
                message: data?.data?.message,
                title: "Update Gallery",
                type: "Success",
              })
            );
          }
        } catch (error) {
          reject(error);
          dispatch(
            showAlert({
              title: "updateCategory",
              message: error?.response?.data?.message,
              type: "Error",
              status: error?.response?.status,
            })
          );
        } finally {
          dispatch(hideLoading());
        }
      });
    };
  },

  getAllClientCategories: (userData) => {
    return (dispatch) => {
      dispatch(showLoading());
      return new Promise(async (resolve, reject) => {
        try {
          let formData = new FormData();
          formData.append("event_id", userData?.event_id);
          if (userData?.category_id)
            formData.append("category_id", userData?.category_id);
          if (userData?.image_name)
            formData.append("image_name", userData?.image_name);

          const data = await Axios.post(
            Apis.getGallery,
            formData,
            await headers.config()
          );
          if (data?.status == 200) {
            dispatch(hideLoading());
            resolve(true);
            dispatch(getGallery(data?.data?.data));
          }
        } catch (error) {
          dispatch(hideLoading());
          reject(error);
          dispatch(
            showAlert({
              title: "getAllClientCategories",
              message: error?.response?.data?.message,
              type: "Error",
              status: error?.response?.status,
            })
          );
        }
      });
    };
  },

  getAllVendorCategories: (userData) => {
    return (dispatch) => {
      dispatch(showLoading());
      return new Promise(async (resolve, reject) => {
        try {
          let formData = new FormData();
          formData.append("event_id", userData?.event_id);
          if (userData?.category_id)
            formData.append("category_id", userData?.category_id);
          if (userData?.image_name)
            formData.append("image_name", userData?.image_name);

          const data = await Axios.post(
            Apis.getVendorGallery,
            formData,
            await headers.config()
          );
          if (data?.status == 200) {
            dispatch(hideLoading());
            resolve(true);
            dispatch(getGallery(data?.data?.data));
          }
        } catch (error) {
          dispatch(hideLoading());
          reject(error);
          dispatch(
            showAlert({
              title: "getAllVendorCategories",
              message: error?.response?.data?.message,
              type: "Error",
              status: error?.response?.status,
            })
          );
        }
      });
    };
  },

  getClientGalleryByCategory: (category_data) => {
    return (dispatch) => {
      dispatch(showLoading());
      return new Promise(async (resolve, reject) => {
        try {
          let formData = new FormData();
          formData.append("event_id", category_data?.event_id);
          formData.append("category_id", category_data?.id);
          if (category_data?.image_name) {
            formData.append("image_name", category_data?.image_name);
          }
          const data = await Axios.post(
            Apis.getGalleryByCatId_ImgName,
            formData,
            await headers.config()
          );

          if (data?.status == 200) {
            dispatch(hideLoading());
            resolve(true);
            dispatch(getSpecificCategory(data?.data?.data));
          }
        } catch (error) {
          dispatch(hideLoading());
          reject(error);
          dispatch(
            showAlert({
              title: "getClientGalleryByCategory",
              message: error?.response?.data?.message,
              type: "Error",
              status: error?.response?.status,
            })
          );
        }
      });
    };
  },

  getVendorGalleryByCategory: (category_data) => {
    return (dispatch) => {
      dispatch(showLoading());
      return new Promise(async (resolve, reject) => {
        try {
          let formData = new FormData();
          formData.append("category_id", category_data?.id);
          formData.append("event_id", category_data?.event_id);
          if (category_data?.image_name) {
            formData.append("image_name", category_data?.image_name);
          }
          const data = await Axios.post(
            Apis.getVendorGalleryByCatId_ImgName,
            formData,
            await headers.config()
          );

          if (data?.status == 200) {
            dispatch(hideLoading());
            resolve(true);
            dispatch(getSpecificCategory(data?.data?.data));
          }
        } catch (error) {
          dispatch(hideLoading());
          reject(error);
          dispatch(
            showAlert({
              title: "getVendorGalleryByCategory",
              message: error?.response?.data?.message,
              type: "Error",
              status: error?.response?.status,
            })
          );
        }
      });
    };
  },

  deletePhotoByID: ({ gallery_id }) => {
    return (dispatch) => {
      dispatch(showLoading());
      return new Promise(async (resolve, reject) => {
        try {
          let formData = new FormData();
          formData.append("id", gallery_id);
          const data = await Axios.post(
            Apis.deleteGalleryPhoto,
            formData,
            await headers.config()
          );

          if (data?.status == 200) {
            resolve(true);
            dispatch(
              showAlert({
                message: data?.data?.message,
                title: "Delete Photo",
                type: "Success",
              })
            );
          }
        } catch (error) {
          reject(error);
          dispatch(
            showAlert({
              title: "deletePhotoByID",
              message: error?.response?.data?.message,
              type: "Error",
              status: error?.response?.status,
            })
          );
        } finally {
          dispatch(hideLoading());
        }
      });
    };
  },

  deleteGalleryByID: (gallery_id) => {
    return (dispatch) => {
      dispatch(showLoading());
      return new Promise(async (resolve, reject) => {
        try {
          let formData = new FormData();
          formData.append("id", gallery_id);
          const data = await Axios.post(
            Apis.deleteGallery,
            formData,
            await headers.config()
          );

          console.log("data", data?.data?.data);
          if (data.status == 200) {
            let dataPayload = data?.data?.data?.images
              ? data?.data?.data?.images
              : [];
            dispatch(deleteGallery(gallery_id));
            // dispatch(updateGallery(dataPayload));
            console.log("data", data);
            dispatch(
              showAlert({
                type: "success",
                title: "deleteGalleryByID",
                message: data?.data?.message,
              })
            );
            resolve(dataPayload);
          }
        } catch (error) {
          console.log("error====================================", error);
          reject(error);
          dispatch(
            showAlert({
              title: "deleteGalleryByID",
              message: error?.response?.data?.message,
              type: "Error",
              status: error?.response?.status,
            })
          );
        } finally {
          dispatch(hideLoading());
        }
      });
    };
  },

  getVendorPhotos: (userData) => {
    return (dispatch) => {
      return new Promise(async (resolve, reject) => {
        try {
          let formData = new FormData();
          formData.append("vendor_id", userData?.id);

          const data = await Axios.post(
            Apis.getVendorAllPhotos,
            formData,
            await headers.config()
          );
          if (data?.status == 200) {
            resolve(true);
            dispatch(getVendorPhotos(data?.data?.data));
          }
        } catch (error) {
          reject(error);
          dispatch(
            showAlert({
              title: "getVendorPhotos",
              message: error?.response?.data?.message,
              type: "Error",
              status: error?.response?.status,
            })
          );
        }
      });
    };
  },
};
